import { gql } from '@apollo/client/index.js'
import { useContentful } from '@ecomm/shared-apollo'
import { footerSchema } from './footerSchema'
import { FOOTER_FRAGMENT } from './footer_fragment'

export const FOOTER_QUERY = gql`
  ${FOOTER_FRAGMENT}
  query FOOTER_QUERY($preview: Boolean!, $locale: String!, $id: String!) {
    footer(id: $id, preview: $preview, locale: $locale) {
      ...footer
    }
  }
`

/**
 * ONLY FOR GATSBY TEMPLATE FILES!
 */
export const useFooterQuery = (id = '2SCKVa13yRuLSU4GuooHlb') => {
  const { data: defaultFooterData } = useContentful(FOOTER_QUERY, { id })

  return footerSchema.parse(defaultFooterData['footer'], {
    path: ['useFooterQuery', 'footer']
  })
}
